import store from "../../../store/store";

export default store("alert");
